import { shorthands, tokens } from '@fluentui/react-components';

export const positionFill = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
};

export const getSharedAssetContainerStyle = () => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  boxSizing: 'border-box',

  // name and ID
  '& .cell-description': {
    display: 'flex',
    flexShrink: 0,
    flexGrow: 0,
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: '12px',
    ...shorthands.margin('12px', '4px'),

    '& .cell-description-name': {
      flexShrink: 1,
      flexGrow: 1,
      ...shorthands.overflow('hidden'),
      marginRight: '12px',
    },

    '& .cell-description-id': {
      flexShrink: 0,
      flexGrow: 0,
    },

    '& .highlighted-text': {
      backgroundColor: tokens.colorPaletteYellowBackground3,
    },
  },
});

export const getSharedMultiSelectingCellStyles = () => ({
  // only show checkbox on overlay if it is NOT in multi-selecting mode
  selectableCardContainerAutoHideCheckbox: {
    '& .cell-image-frame': {
      ...shorthands.overflow('hidden'),
      ...shorthands.borderRadius('6px'),
    },

    '& .selected-checkbox': {
      visibility: 'hidden',
    },

    '&:hover': {
      '& .selected-checkbox': {
        visibility: 'visible',
        // '& .ms-Checkbox-checkbox': {
        //   ...shorthands.border('2px solid white !important'),
        // },
        '& .ms-Checkbox-checkmark': {
          color: tokens.colorNeutralForegroundInverted,
        },
      },
    },

    '& .visible-checkbox': {
      visibility: 'visible',
      // '& .ms-Checkbox-checkbox': {
      //   border: '2px solid white !important',
      // },
      '& .ms-Checkbox-checkmark': {
        color: tokens.colorNeutralForegroundInverted,
      },
    },
  },

  selectableCardContainer: {
    '& .cell-image-frame': {
      ...shorthands.overflow('hidden'),
      ...shorthands.borderRadius('6px'),
    },

    '& .selected-checkbox': {
      visibility: 'visible',
      // '& .ms-Checkbox-checkbox': {
      //   border: '2px solid white !important',
      // },
      '& .ms-Checkbox-checkmark': {
        color: tokens.colorNeutralForegroundInverted,
      },
    },
  },
});
